/* eslint-disable react/no-array-index-key */
import {
  Flex,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
} from "@chakra-ui/react";
import { BiChevronDown } from "react-icons/bi";
import { NavLink } from "react-router-dom";

export function MenuItemLink({ to, label, icon, children }) {
  if (children) {
    return (
      <div className="header-dropdown">
        <Menu>
          <MenuButton
            className="toggle "
            fontWeight={600}
            p={0}
            backgroundColor="transparent !important"
            sx={{
              "--chakra-colors-secondary": "transparent",
            }}
            as={Button}
            rightIcon={<BiChevronDown />}
          >
            <Flex align="center" gap="7px" to={to} as={NavLink} fontSize="14px">
              {icon}
              {label}
            </Flex>
          </MenuButton>
          <MenuList>
            {children.map((element, index) => {
              return (
                <MenuItem key={index} as={NavLink} to={element.link}>
                  {element.label}
                </MenuItem>
              );
            })}
          </MenuList>
        </Menu>
      </div>
    );
  }
  return (
    <Flex
      align="center"
      gap="7px"
      to={to}
      as={NavLink}
      fontSize={{ base: "10px", md: "14px" }}
      sx={{
        "&.active": {
          color: "primary.500",
          fontWeight: "600",
        },
      }}
    >
      {icon}
      {label}
    </Flex>
  );
}
